import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { RelativeConditionIndex } from '../../types/device';

type ContextState = Data<RelativeConditionIndex>;
const Context = React.createContext<ContextState | null>(null);

function useRelativeConditionIndexDetail(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useRelativeConditionIndex details must be used within a Relative Condition Index');
    }
    return contextState;
}
const RelativeConditionIndexProvider: React.FC<{ deviceId: string; startMonthAndYear?: string; endMonthAndYear?: string}> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'relative-status',
        id: props.deviceId,
        dataFn: React.useCallback(() => ChartManager.getRelativeConditionIndexApiResponse(authHelper, props.deviceId,props.startMonthAndYear,props.endMonthAndYear), [
            authHelper,
            props.deviceId,
        ])
    });

    const conditionIndexResponseData = dataFromDataset(dataset);   
    return <Context.Provider value={conditionIndexResponseData}>{props.children}</Context.Provider>;
};

const TestRelativeConditionIndexProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { RelativeConditionIndexProvider, TestRelativeConditionIndexProvider, useRelativeConditionIndexDetail };
